<template>
  <v-expansion-panels :class="{'total-header-extend--active' : typeof value === 'number'}" class="pa-0 total-header-extend" :value="value" @change="updateValue($event)">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <h3>Totals</h3>
      </v-expansion-panel-header>

      <v-expansion-panel-content>

        <v-simple-table dense style="overflow: auto; max-height: calc(100vh - 130px);">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="total-table-head" v-for="header in headers" :key="header.value">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="options.totalCalculate">
                <total-calculate-sub
                  v-for="row in totalSubGroupByFiltredRows"
                  :key="row.id"
                  :rowData="row"
                  :headers="headers"
                  :shadowTotalTitle="true"
                  :options="options"
                />
                <total-calculate-rows
                  v-if="totalByFiltredRows"
                  :rowData="totalByFiltredRows"
                  :headers="headers"
                  :options="options"
                />
              </template>
            </tbody>
          </template>
        </v-simple-table>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import TotalCalculateSub from '@/components/report/TotalRows/TotalCalculateSub.vue'
  import TotalCalculateRows from '@/components/report/TotalRows/TotalCalculateRows.vue'

  export default {
    name: 'TotalTableInSelect',
    components: { TotalCalculateRows, TotalCalculateSub },
    emits: [ 'input' ],
    props: {
      totalByFiltredRows: [ Boolean, Object ],
      totalSubGroupByFiltredRows: [ Boolean, Array ],
      options: Object,
      totalTableHeader: Array,
      value: [ Number, Boolean ]
    },

    methods: {
      updateValue (newValue) {
        this.$emit('input', newValue)
      },
    },

    computed: {
      headers () {
        return this.totalTableHeader.filter(o => o.value !== this.options?.totalCalculate?.titleField)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .total-table {
    width: 100%;

    &-head {
      text-align: left;
    }

    td {
    }
  }

  .total-header-extend {
    max-height: 48px;

    &--active {
      min-width: fit-content;
      position: absolute;
      right: 0px;
    }
  }
</style>
